const icon = new URL('../../icons/carrier.png', import.meta.url).href

export default {
  type: 'carrier',
  description: 'Carrier (Pallet/Box)',
  group: 'warehouse' /* line|shape|textAndMedia|chartAndGauge|table|container|dataSource|IoT|3D|warehouse|form|etc */,
  icon,
  model: {
    type: 'carrier',
    left: 100,
    top: 100,
    width: 100,
    height: 80,
    depth: 30,
    fillStyle: '#c4a265',
    strokeStyle: '#999',
    lineWidth: 1,
    alpha: 1
  }
}
